import { FacebookAdAccount } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchFacebookAccounts = (): Promise<FacebookAdAccount[]> =>
    privateApiWithRouteLeavingCancelation.get<FacebookAdAccount[]>('facebook/graph/ad-accounts');

export const CancelableFacebookAdAccountGateway = {
    cancelableFetchFacebookAccounts,
};
